import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestExportConsentsGet = {
    path: "/export/consents",
    method: RouteHttpVerb.GET
};
export { locationRestExportConsentsGet };
